import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getDefaultPath, hasPermission, refreshSession } from "./auth";

export default function RequireAuth({ children, permission }) {
  const location = useLocation();
  const [state, setState] = React.useState({ loading: true, user: null });

  React.useEffect(() => {
    let active = true;
    refreshSession().then((user) => { if (active) setState({ loading: false, user }); });
    return () => { active = false; };
  }, []);

  if (state.loading) return <div className="flex min-h-screen items-center justify-center bg-[#f7ecd9] text-[#6b5a4b]">Validando acesso...</div>;
  if (!state.user) return <Navigate to="/login" replace state={{ from: location }} />;
  if (state.user.userType === "sales_promoter" && permission !== "ipdv_promoter") return <Navigate to="/promotor-vendas" replace />;
  if (permission && !hasPermission(permission, state.user)) return <Navigate to={getDefaultPath(state.user)} replace />;
  return children;
}
